import { render, staticRenderFns } from "./InventoryRecord.vue?vue&type=template&id=e2dcf0a0&"
import script from "./InventoryRecord.vue?vue&type=script&lang=ts&"
export * from "./InventoryRecord.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports